import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'flex-start',

    backgroundColor: theme.palette.background.default,
  },
  headersContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    minHeight: '4rem',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.primary.contrastText,
    backgroundColor: '#F2F2F2',

    '& h1': {
      margin: '0 0.5rem',
      fontSize: '1.6rem',
    },
    '& h2': {
      margin: '0.5rem 0 0 0.5rem',
      fontSize: '1.1rem',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '40rem',
    height: '16rem',
    padding: '3rem 2rem 2rem 2rem',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.background.paper,
  },
}));
